import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { CAR_TRAWLER_SECTION_ID } from "../defines";
import { loadCarSection } from "../loadCarSection";

/**
 * This component commits the custom Angular element into the DOM for the Smartblock.
 * @param {*} props
 * @returns
 */
export const CarSection = (props) => {
  const { loadScript = true, options, site } = props;

  useEffect(() => {
    if (loadScript) {
      loadCarSection(options);
    }
  }, [loadScript]);

  return (
    <div id={CAR_TRAWLER_SECTION_ID}>
      <ct-smartblock-sb4
        data-config-name={site === "corporate" ? "swabiz" : "southwest"}
      ></ct-smartblock-sb4>
    </div>
  );
};

CarSection.propTypes = {
  /** Flag to indicate if the Smartblock loader script should be executed immediately on component load. */
  loadScript: PropTypes.bool,

  /** Configuration object to render various layouts per use case. */
  options: PropTypes.object,

  /** Indicates if the user is on leisure or swabiz flow. */
  site: PropTypes.oneOf(["leisure", "corporate"]),
};
